import React from "react";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import { DataGridItem } from "components/data-grid";
import FormTextField from "components/form/form-textfield";
import { UserSelect } from "components/select";
import { ContractSelect } from "../../../../components/select";

const EditCustomerForm = ({ intl, values, handleChange, customerId }) => {
  return (
    <>
      <DataGridItem big>
        <FormTextField
          type="text"
          id="description"
          name="description"
          value={values.description}
          onChange={handleChange}
          label={intl.formatMessage({ id: "common.description" })}
        />
      </DataGridItem>
      <DataGridItem big>
        <ContractSelect
          multiple
          id="contractIds"
          name="contractIds"
          label={intl.formatMessage({ id: "customer.contracts" })}
          handleChange={handleChange}
          value={values.contractIds}
          contractsWithoutCustomer
          customerId={customerId}
        />
      </DataGridItem>
      <DataGridItem big>
        <UserSelect
          excludePartnerUsers
          multiple
          isInsideForm
          id="userIds"
          name="userIds"
          label={intl.formatMessage({ id: "customer.users" })}
          onChange={handleChange}
          value={values.userIds}
        />
      </DataGridItem>
    </>
  );
};

EditCustomerForm.propTypes = {
  /**
   * Valores del formulario
   */
  values: PropTypes.object,
  /**
   * Callback que se dispara con el cambio del input
   */
  handleChange: PropTypes.func,
};

export default injectIntl(EditCustomerForm);
